<template>
  <div class="page__keyword a-page">
    <div style="background-color:white; padding:10px; border-radius: 4px; overflow: hidden">
      <el-row>
        <el-col :sm="12">
          <p style="font-size: 14px !important;">{{ $t('menu.atosa_keyword_tool') }} (<strong
            style="font-size: 14px !important;">Agency</strong>)
          </p>
        </el-col>
        <el-col :sm="12" class="text-right">
        </el-col>
      </el-row>

      <br><br>
      <el-row>
        <el-col :sm="3" style="padding-right: 20px">
          <el-select size="mini" value="" v-model="filter.page_size" class="full-w">
            <el-option v-for="item in filter.pages" :key="item" :value="item" :label="item"></el-option>
          </el-select>
        </el-col>
        <el-col :sm="4">
          <el-select v-model="filter.selected_industry" size="mini" value="" class="full-w">
            <el-option :label="'Tất cả ngành hàng'" value=""></el-option>
            <el-option v-for="item of industries" :key="item.id" :value="item.id" :label="item.name"></el-option>
          </el-select>
        </el-col>
        <el-col :sm="5" style="padding-left: 20px">
          <el-input v-model="filter.search_keyword" size="mini" :placeholder="$t('input.placeholder')"></el-input>
        </el-col>
        <el-col :sm="12" class="text-right">
          <el-button size="mini" type="primary" icon="el-icon-info" @click="m__show_industry_dialog">Quản lý Ngành hàng
          </el-button>
          <el-button size="mini" type="primary" icon="el-icon-plus" @click="m__show_industry_keyword_dialog">
            Thêm từ khóa
          </el-button>
        </el-col>
      </el-row>

      <el-table :data="industry_keywords">
        <el-table-column type="index" label="#"></el-table-column>
        <el-table-column prop="keyword" :label="$t('base.keyword')"></el-table-column>
        <el-table-column prop="industry.name" :label="$t('base.category')"></el-table-column>
        <el-table-column :label="$t('base.created_at')">
          <template slot-scope="scope">
            {{ scope.row.createdAt | moment }}
          </template>
        </el-table-column>
        <el-table-column label="Ngày cập nhật gần nhất">
          <template slot-scope="scope">
            {{ scope.row.updatedAt | moment('DD-MM-YYYY HH:mm') }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('base.action')" width="350px">
          <template slot-scope="scope">
            <el-button size="mini" type="info" icon="el-icon-info" @click="m__show_get_current_keywords(scope.row)">
              Xem từ khóa
            </el-button>
            <el-button :disabled="scope.row.status !== 'PENDING'" size="mini" type="primary"
                       :icon="scope.row.status === 'PENDING' ? 'el-icon-check' : 'el-icon-loading'"
                       @click="m__get_keywords(scope.row)">
              <template v-if="scope.row.status === 'PENDING'">Lấy dữ liệu</template>
              <template v-if="scope.row.status === 'RUNNING'">Đang lấy dữ liệu</template>
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-dialog :visible.sync="show_dialog.create_industry" :close-on-click-modal="false"
               width="500px">
      <div slot="title" style="padding:10px">
        <strong style="font-size: 14px">Quản lý ngành hàng</strong>
        <br>
        <br>
        <br>

        <el-row>
          <el-col :sm="12">
            <el-input v-model="industry_name" size="mini" placeholder="Nhập tên ngành hàng..."></el-input>
          </el-col>
          <el-col :sm="12" style="padding-left: 20px">
            <el-button size="mini" type="primary" icon="el-icon-plus" :loading="loading.create_industry"
                       @click="m__create_industry">Thêm dữ liệu
            </el-button>
          </el-col>
        </el-row>

        <br>
        <br>
        <br>
        <strong style="font-size: 14px">Ngành hàng đã thêm</strong>
        <el-table :data="industries">
          <el-table-column label="Tên ngành hàng" prop="name"></el-table-column>
          <el-table-column :label="$t('base.action')"></el-table-column>
        </el-table>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="show_dialog.create_keyword_industry" :close-on-click-modal="false"
               width="500px">
      <div slot="title" style="padding:10px">
        <strong style="font-size: 14px">Thêm từ khóa ngành</strong>
        <br>
        <br>
        <br>

        <p class="text-title">Từ khóa</p>
        <el-input v-model="industry_keyword_form.keyword" size="mini" placeholder="Nhập từ khóa ngành..."></el-input>

        <p class="text-title">Ngành hàng</p>
        <el-select v-model="industry_keyword_form.industryId" size="mini" value="" class="full-w"
                   placeholder="Chọn ngành hàng">
          <el-option v-for="item of industries" :key="item.id" :value="item.id" :label="item.name"></el-option>
        </el-select>

        <div style="margin-top: 20px" class="text-right">
          <el-button size="mini" icon="el-icon-plus" :loading="loading.create_keyword_industry"
                     type="primary" @click="m__create_industry_keyword">
            Thêm từ khóa ngành
          </el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="show_dialog.get_keyword_currents" :close-on-click-modal="false"
               width="400px">
      <div slot="title" style="padding:10px">
        <p class="text-title">Số lượng bản ghi (Tối đa {{ max_top }} bản ghi):</p>
        <el-input size="mini" placeholder="Nhập số lượng bản ghi muốn lấy..." type="number" :max="max_top"
                  v-model="top"></el-input>

        <br>
        <br>
        <div class="text-right">
          <el-button size="mini" type="primary" :loading="loading.get_keyword_currents"
                     @click="m__get_current_keywords">Xem dữ liệu
          </el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="show_dialog.keyword_currents" :close-on-click-modal="false"
               width="1000px">
      <div slot="title" style="padding:10px">
        <el-row>
          <el-col :sm="20">
            <p style="font-size: 14px">Danh sách từ khóa liên quan - Từ khóa ngành hàng: <strong
              style="font-size: 14px">{{ selected_industry_keyword ? selected_industry_keyword.keyword : '' }}</strong>
            </p>
          </el-col>
          <el-col :sm="4">
            <el-button size="mini" type="primary" icon="el-icon-download" @click="m__download_current_keywords">
              Tải file excel
            </el-button>
          </el-col>
        </el-row>
        <br>

        <el-table :data="current_keywords">
          <el-table-column prop="keyword" :label="$t('base.keyword')"></el-table-column>
          <el-table-column prop="atosaVolume" label="Atosa Volume" sortable>
            <template slot-scope="scope">
              {{ scope.row.atosaVolume | currency }}
            </template>
          </el-table-column>
          <el-table-column prop="shopeeVolume" label="Shopee Volume" sortable>
            <template slot-scope="scope">
              {{ scope.row.shopeeVolume | currency }}
            </template>
          </el-table-column>
          <el-table-column prop="updatedAt" label="Ngày cập nhật">
            <template slot-scope="scope">
              {{ scope.row.updatedAt | moment('DD-MM-YYYY HH:mm') }}
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {check_channel, show_expr_notification} from '../../addon/check_license'

export default {
  name: 'page__agency_keyword',

  data() {
    return {
      filter: {
        pages: [10, 20, 30, 40, 50, 100],
        page_size: 10,
        current_page: 0,
        total_record: 0,
        search_keyword: '',
        selected_industry: ''
      },
      loading: {
        create_industry: false,
        create_keyword_industry: false,
        get_keyword_industries: false,
        get_keyword_currents: false
      },
      show_dialog: {
        create_industry: false,
        create_keyword_industry: false,
        get_keyword_currents: false,
        keyword_currents: false
      },
      industry_name: '',
      industries: [],
      industry_keywords: [],
      industry_keyword_form: {
        mipeeUserId: '',
        keyword: '',
        industryId: ''
      },
      selected_industry_keyword: null,
      top: null,
      max_top: 500,
      current_keywords: []
    }
  },

  beforeRouteEnter(to, from, next) {
    if (check_channel('shopee_agency')) {
      next()
    } else {
      show_expr_notification()
      next('/')
    }
  },

  async beforeMount() {
    await this.m__get_industries()
    await this.m__get_industry_keywords()
  },

  methods: {
    m__show_industry_dialog() {
      this.show_dialog.create_industry = true
    },

    m__show_industry_keyword_dialog() {
      this.show_dialog.create_keyword_industry = true
    },

    async m__get_industries() {
      const response = await this.$http.get(this.API.URL_API_SRV_1 + '/keywords/industries', {
        ...this.cf(),
        params: {mipeeUserId: this.$store.state.userInfo.username}
      })
      this.industries = response.data
    },

    async m__get_industry_keywords() {
      const response = await this.$http.get(this.API.URL_API_SRV_1 + '/keywords/industry_keywords', {
        ...this.cf(),
        params: {mipeeUserId: this.$store.state.userInfo.username}
      })
      for (const item of response.data) {
        item.industry = this.industries.find(i => i.id === item.industryId)
      }
      this.industry_keywords = response.data
    },

    async m__create_industry() {
      if (!this.industry_name) {
        return
      }

      this.loading.create_industry = true
      try {
        await this.$http.post(this.API.URL_API_SRV_1 + '/keywords/industries', {
          mipeeUserId: this.$store.state.userInfo.username,
          name: this.industry_name
        }, this.cf())
        await this.m__get_industries()
        this.industry_keywords = ''
        this.ntf_s('Thêm thành công')
      } catch (e) {
        this.ntf_w(this.$t('base.has_an_occurred'))
      } finally {
        this.loading.create_industry = false
      }
    },

    async m__create_industry_keyword() {
      if (!this.industry_keyword_form.keyword) {
        this.ntf_w('Từ khóa không được để trống')
        return
      }

      if (!this.industry_keyword_form.industryId) {
        this.ntf_w('Ngành hàng không được để trống')
        return
      }

      this.loading.create_keyword_industry = true
      try {
        await this.$http.post(this.API.URL_API_SRV_1 + '/keywords/industry_keywords', {
          mipeeUserId: this.$store.state.userInfo.username,
          keyword: this.industry_keyword_form.keyword,
          industryId: this.industry_keyword_form.industryId
        }, this.cf())
        await this.m__get_industry_keywords()
        this.ntf_s('Thêm từ khóa thành công')
        this.show_dialog.create_keyword_industry = false
      } catch (e) {
        this.ntf_w(this.$t('base.has_an_occurred'))
      } finally {
        this.loading.create_keyword_industry = false
      }
    },

    async m__show_get_current_keywords(data) {
      this.selected_industry_keyword = data
      this.show_dialog.get_keyword_currents = true
    },

    async m__get_current_keywords() {
      if (!this.top || this.top > this.max_top) {
        this.ntf_w(`Số lượng bản ghi tối đa là ${this.max_top}`)
        return
      }

      this.loading.get_keyword_currents = true
      try {
        const resp = await this.$http.get(this.API.URL_API_SRV_1 + '/keywords/current_keywords', {
          ...this.cf(),
          params: {
            mipeeUserId: this.$store.state.userInfo.username,
            industryKeywordId: this.selected_industry_keyword.id,
            top: this.top
          }
        })

        this.current_keywords = resp.data
        this.show_dialog.get_keyword_currents = false
        this.show_dialog.keyword_currents = true
      } catch (e) {
        this.ntf_w(this.$t('base.has_an_occurred'))
      } finally {
        this.loading.get_keyword_currents = false
      }
    },

    async m__download_current_keywords() {
      const response = await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/current-keywords-excel', {
        data: this.current_keywords
      }, {
        ...this.cf(),
        responseType: 'blob'
      })

      const url = window.URL.createObjectURL(new Blob([response.body]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', `keyword.xlsx`)
      document.body.appendChild(link)
      link.click()
    },

    async m__get_keywords(keyword) {
      await this.$http.get(this.API.URL_API_SRV_2 + '/mipee/agency/get-agency-keywords', {
        ...this.cf(),
        params: {industryKeywordId: keyword.id}
      })
      await this.m__get_industry_keywords()
    }
  }
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/pages/agency/keyword.vue